import { AlertTriangle, RefreshCw, Home } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ErrorFallbackProps {
  error: Error;
  resetError: () => void;
  level?: "page" | "feature";
}

export const ErrorFallback = ({ error, resetError, level = "feature" }: ErrorFallbackProps) => {
  const isPageLevel = level === "page";

  return (
    <div className="flex items-center justify-center min-h-[400px] p-6">
      <div className="text-center max-w-md">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-destructive/10 mb-4">
          <AlertTriangle className="w-8 h-8 text-destructive" />
        </div>
        
        <h2 className="text-2xl font-semibold mb-2">
          {isPageLevel ? "Page Error" : "Something went wrong"}
        </h2>
        
        <p className="text-muted-foreground mb-6">
          {isPageLevel 
            ? "We encountered an error loading this page. Please try again."
            : "This feature encountered an error. You can try refreshing or continue browsing."
          }
        </p>

        {process.env.NODE_ENV === "development" && (
          <pre className="text-left text-xs bg-muted p-3 rounded-md mb-4 overflow-auto max-h-32">
            {error.message}
          </pre>
        )}

        <div className="flex gap-3 justify-center">
          <Button onClick={resetError} variant="default">
            <RefreshCw className="w-4 h-4 mr-2" />
            Try Again
          </Button>
          
          {isPageLevel && (
            <Button onClick={() => window.location.href = "/"} variant="outline">
              <Home className="w-4 h-4 mr-2" />
              Go Home
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
